import React, { useState } from 'react';
import { Button, Row, Col, Card, CardBody } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DealerStatus, DealerStatusName } from '../constants/DealerStatus';

function DealersStatusFilter({ onChangeStatus, previousSelectedStatus }) {
  const [selected, setSelected] = useState(previousSelectedStatus || '');

  const handleClick = (status) => {
    setSelected(status);
    onChangeStatus(status);
  };

  const getButtonClass = (status) =>
    classNames(status !== selected ? 'btn-soft-primary' : 'btn-primary');

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <div className="d-flex gap-2 flex-wrap">
              <Button
                className={classNames('rounded-pill', getButtonClass(''))}
                onClick={() => handleClick('')}
              >
                All
              </Button>
              {Object.entries(DealerStatus).map(([status]) => (
                <Button
                  key={status}
                  className={classNames('rounded-pill', getButtonClass(status))}
                  onClick={() => handleClick(DealerStatus[status])}
                >
                  {DealerStatusName[status]}
                </Button>
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

DealersStatusFilter.propTypes = {
  onChangeStatus: PropTypes.func.isRequired,
  previousSelectedStatus: PropTypes.string,
};

DealersStatusFilter.defaultProps = {
  previousSelectedStatus: '',
};

export default DealersStatusFilter;
